import React from 'react';
import S from './TitleGroup.styled';

interface TitleGroupProps {
  boldTitle: string;
  regularTitle: string;
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  color?: string;
  styledAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  mobileStyledAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const TitleGroup: React.FC<TitleGroupProps> = ({
  boldTitle,
  regularTitle,
  type,
  color,
  styledAs,
  mobileStyledAs,
}) => {
  const Heading = type;

  return (
    <Heading>
      {boldTitle && (
        <S.BoldSpan $type={type} $color={color} $styledAs={styledAs}>
          {boldTitle}
        </S.BoldSpan>
      )}
      <br />
      {regularTitle && (
        <S.RegularSpan
          $type={type}
          $color={color}
          $styledAs={styledAs}
          $mobileStyledAs={mobileStyledAs}
        >
          {regularTitle}
        </S.RegularSpan>
      )}
    </Heading>
  );
};

export default TitleGroup;
